

document.addEventListener('click', function(event) {
    if (!event.target.closest('.card-variant-form')) return;
    const button = event.target.closest('.card-variant-option');
    if (!button) return;

    const options = button.closest('.card-variant-options');
    const card = button.closest('.product-card-wrapper');
    const form = button.closest('form');
    const variantInput = form.querySelector('.card-variant-id');
    const priceEl = document.getElementById('CardPrice-' + options.dataset.productCard);
    const image = card.querySelector('.card__media img');

    options.querySelectorAll('.card-variant-option').forEach(function(option) {
        option.classList.remove('is-active');
    });

    button.classList.add('is-active');
    variantInput.value = button.dataset.variantId;
    const isAvailable = button.dataset.available === 'true';
    const submitButton = form.querySelector('button[type="submit"]');
    const submitText = submitButton?.querySelector('span');

    variantInput.disabled = false;

    if (submitButton && submitText) {
    submitButton.disabled = !isAvailable;
    submitText.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    if (priceEl) {
        const regular = priceEl.querySelector('.price__regular .price-item--regular');
        const sale = priceEl.querySelector('.price__sale .price-item--sale');
        const compare = priceEl.querySelector('.price__sale .price-item--regular');
        const priceWrapper = priceEl.querySelector('.price');

        if (button.dataset.hasCompare === 'true') {
        if (regular) regular.textContent = button.dataset.price;
        if (sale) sale.textContent = button.dataset.price;
        if (compare) compare.textContent = button.dataset.comparePrice;
        if (priceWrapper) priceWrapper.classList.add('price--on-sale');
        } else {
        if (regular) regular.textContent = button.dataset.price;
        if (sale) sale.textContent = button.dataset.price;
        if (compare) compare.textContent = '';
        if (priceWrapper) priceWrapper.classList.remove('price--on-sale');
        }
    }

    if (image && button.dataset.image) {
        image.removeAttribute('srcset');
        image.src = button.dataset.image;
    }
});
